import { ChangeEvent, FC } from "react";
import InputIcon from "../../../components/atoms/InputIcon";
import styles from "./styles.scss";

interface ImageInputIconProps {
  karteImageAttachments?: File[];
  setKarteImageAttachments: (value: File[]) => void;
}

export const ImageInputIcon: FC<ImageInputIconProps> = ({
  karteImageAttachments,
  setKarteImageAttachments,
}) => {
  return (
    <InputIcon
      iconName="icon-picture-img"
      inputAttributes={{
        accept: "image/jpeg,image/gif,image/png",
        id: "karte_image_attachments_attributes",
        type: "file",
      }}
      className={styles.footer__icon}
      tooltipLabel="画像の追加( jpg,png,gif )"
      onChange={handleAddImageAttachment(
        karteImageAttachments,
        setKarteImageAttachments,
      )}
    />
  );
};

const handleAddImageAttachment =
  (
    karteImageAttachments: File[] | undefined,
    setKarteImageAttachments: (value: File[]) => void,
  ) =>
  (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.currentTarget.files?.[0];
    if (!file) {
      return;
    }
    setKarteImageAttachments([...(karteImageAttachments ?? []), file]);
  };
